import React from 'react';
import PropTypes from 'prop-types';
import LossToActionOverview from '../../LossToAction/LossToActionOverview';
const OrderToAllocationOverviewtable = ({
    data,
    columns,
    paginationData,
    sortingData,
    handlePageChange,
    isLoading = false
}) => {
    const scrollableColumnsArray = ['Order Loss Bucket','Order details','Customer Details','Freshness led loss validity','Order Loss Details','Order To Allocation Loss validity','Order validity details','PO Details','Reason of loss and loss bucket','Supply led loss validity'];
    return (
        <div style={{marginTop:"10px"}}>
        <LossToActionOverview
            data={data}
            columns={columns}
            paginationData={paginationData}
            sortingData={sortingData}
            handlePageChange={handlePageChange}
            isLoading={isLoading}
            scrollableColumnsArray={scrollableColumnsArray}
            totalColumnName="Format"
            fixedColumnName="Format"
            tableType="Order To Allocation Overview"
        />
        </div>
    );
};

OrderToAllocationOverviewtable.propTypes = {
    data: PropTypes.array,
    columns: PropTypes.array,
    paginationData: PropTypes.object,
    sortingData: PropTypes.object,
    handlePageChange: PropTypes.func,
    isLoading: PropTypes.bool
};

export default OrderToAllocationOverviewtable;
